var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"insights-page"},[_c('activities'),_c('top-startups'),_c('top-funded-categories')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar topbar--full"},[_c('h2',{staticClass:"heading2 pt-4 mb-0"},[_vm._v("Insights")])])
}]

export { render, staticRenderFns }